// extracted by mini-css-extract-plugin
export var localeSelector = "_44-0";